import React from 'react';
import { Search, Filter, X, Calendar } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const MONTHS = [
    { value: 1, label: 'Janvier' },
    { value: 2, label: 'Février' },
    { value: 3, label: 'Mars' },
    { value: 4, label: 'Avril' },
    { value: 5, label: 'Mai' },
    { value: 6, label: 'Juin' },
    { value: 7, label: 'Juillet' },
    { value: 8, label: 'Août' },
    { value: 9, label: 'Septembre' },
    { value: 10, label: 'Octobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Décembre' },
];

export { MONTHS };

export const CatalogueFilters = ({
    search,
    onSearchChange,
    onSearchSubmit,
    selectedCategory,
    selectedCategoryData,
    onCategoryChange,
    selectedSeason,
    onSeasonChange,
    categories,
    onClearFilters,
}) => (
    <>
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <form onSubmit={onSearchSubmit} className="flex-1 flex gap-2">
                <div className="relative flex-1">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                        placeholder="Rechercher un produit..."
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="pl-10 bg-white/80 border-jungle/20 focus:border-leaf rounded-xl"
                        data-testid="search-input"
                    />
                </div>
                <Button type="submit" variant="secondary" className="bg-jungle/10 hover:bg-jungle/20 text-jungle rounded-xl" data-testid="search-button">
                    Rechercher
                </Button>
            </form>

            <Select value={selectedCategory || 'all'} onValueChange={onCategoryChange}>
                <SelectTrigger className="w-full sm:w-[220px] bg-white/80 border-jungle/20 rounded-xl" data-testid="category-filter">
                    <Filter className="h-4 w-4 mr-2 text-leaf" />
                    <SelectValue placeholder="Filtrer par famille" />
                </SelectTrigger>
                <SelectContent className="bg-white/95 backdrop-blur-xl">
                    <SelectItem value="all">Toutes les familles</SelectItem>
                    {categories.map((cat) => (
                        <SelectItem key={cat.id} value={cat.id}>{cat.name}</SelectItem>
                    ))}
                </SelectContent>
            </Select>

            <Select value={selectedSeason || 'all'} onValueChange={onSeasonChange}>
                <SelectTrigger className="w-full sm:w-[180px] bg-white/80 border-jungle/20 rounded-xl" data-testid="season-filter">
                    <Calendar className="h-4 w-4 mr-2 text-amber-500" />
                    <SelectValue placeholder="Filtrer par saison" />
                </SelectTrigger>
                <SelectContent className="bg-white/95 backdrop-blur-xl">
                    <SelectItem value="all">Toutes saisons</SelectItem>
                    <SelectItem value="now" className="text-emerald-600 font-medium">En saison maintenant</SelectItem>
                    <div className="border-t my-1" />
                    {MONTHS.map((month) => (
                        <SelectItem key={month.value} value={month.value.toString()}>{month.label}</SelectItem>
                    ))}
                </SelectContent>
            </Select>

            {(search || selectedCategory || selectedSeason) && (
                <Button variant="ghost" onClick={onClearFilters} className="hover:bg-destructive/10 text-destructive rounded-xl" data-testid="clear-filters">
                    <X className="h-4 w-4 mr-2" />Effacer
                </Button>
            )}
        </div>

        {/* Active Filter Badges */}
        {(search || selectedCategory || selectedSeason) && (
            <div className="flex flex-wrap gap-2 mb-6">
                {search && (
                    <Badge variant="secondary" className="gap-1 bg-jungle/10 text-jungle rounded-full px-3">
                        Recherche: {search}
                        <X className="h-3 w-3 cursor-pointer ml-1" onClick={() => onSearchChange('')} />
                    </Badge>
                )}
                {selectedCategoryData && (
                    <Badge variant="secondary" className="gap-1 rounded-full px-3" style={{ backgroundColor: selectedCategoryData.color + '20', color: selectedCategoryData.color }}>
                        {selectedCategoryData.name}
                        <X className="h-3 w-3 cursor-pointer ml-1" onClick={() => onCategoryChange('all')} />
                    </Badge>
                )}
                {selectedSeason && (
                    <Badge variant="secondary" className="gap-1 bg-amber-100 text-amber-700 rounded-full px-3">
                        <Calendar className="h-3 w-3" />
                        {selectedSeason === 'now'
                            ? 'En saison maintenant'
                            : `Saison: ${MONTHS.find(m => m.value === parseInt(selectedSeason))?.label || selectedSeason}`}
                        <X className="h-3 w-3 cursor-pointer ml-1" onClick={() => onSeasonChange('all')} />
                    </Badge>
                )}
            </div>
        )}
    </>
);
